<div class="modalPdfViewer">
    <div class="modalPdfViewerHeader">
        <span style="flex: 1">Visualisation de {{data.fileName}}</span>
        <mat-icon mat-dialog-close>close</mat-icon>
    </div>

    <div class="modalPdfViewerContent">
        <iframe style="width: 100%; height: 100%" [src]="getUrl()">
        </iframe>
    </div>
</div>
